import { render, staticRenderFns } from "./AddClassConstituentForm.vue?vue&type=template&id=0d6c12dc&"
import script from "./AddClassConstituentForm.vue?vue&type=script&lang=js&"
export * from "./AddClassConstituentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports